import { Routes } from '@angular/router';

import { aiSegments } from '@advania-cosoftware/wolf-router';

export function wolfAiRoutes(): Routes {
    return [
        {
            path: aiSegments.aiChat,
            loadComponent: () => import('./features/ai-chat/page/ai-chat.page').then((module) => module.WolfAiChatPage),
        },
    ];
}
